module.exports = __webpack_public_path__ + "static/LogoArabic_header-de661b50d96f3cd9efe5d0e42bbcc058.svg";